import React from 'react'
import PropTypes from 'prop-types'
import { useThemeMode } from './theme'

// The MySwimPro lockup: white on the dark palette, navy on the light one.
const BrandLogoComponent = ({ className }) => {
  const mode = useThemeMode()
  const file = mode === 'dark' ? 'msp-logo.svg' : 'msp-logo-dark.svg'
  return (
    <img
      className={className}
      src={`${process.env.PUBLIC_URL}/${file}`}
      alt="MySwimPro"
    />
  )
}

BrandLogoComponent.propTypes = {
  className: PropTypes.string
}

export default BrandLogoComponent
